import { render, staticRenderFns } from "./FederationPlanShare.vue?vue&type=template&id=56734656&scoped=true"
import script from "./FederationPlanShare.vue?vue&type=script&lang=js"
export * from "./FederationPlanShare.vue?vue&type=script&lang=js"
import style0 from "./FederationPlanShare.vue?vue&type=style&index=0&id=56734656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56734656",
  null
  
)

export default component.exports